import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  LOCALE_ID,
  OnInit,
  OnChanges
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
} from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarDateFormatter } from 'angular-calendar';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { registerLocaleData } from '@angular/common';

import localeEs from '@angular/common/locales/es-MX';
import { VerCalendario, NewTask } from '../../../models/tarea/tarea.module';
import { UserService } from '../../../services/user.service';
import { CategoryService } from '../../../services/category.service';
import { TareasService } from '../../../services/tareas.service';
registerLocaleData(localeEs, 'es');
import { map } from 'rxjs/operators';
declare var $: any;

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};


@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css'],
  providers: [ { provide: LOCALE_ID, useValue: 'es-MX' } ],

})
export class CalendarioComponent  implements OnInit {

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  refresh: Subject<any> = new Subject();
  activeDayIsOpen: boolean = true;
  token:string;
  tarea: VerCalendario;
  datos_tareas: any;
  events: CalendarEvent[] = [];
  allevents: CalendarEvent[] = [];
  ver_info: boolean = false;
  ver_tarea: NewTask;
  id_us;
  agregar_usuario: any;
  t:any;
  constructor(private modal: NgbModal,private _userService: UserService, private _categoryService: CategoryService, private _tareasService: TareasService) {
    const user = this._userService.getIdentity();
    const token = this._userService.getToken();
    this.token = token;
    this.id_us = user.sub;
    this.t = user.t;
    this.tarea = new VerCalendario(0, user.sub, this.t);

    this._tareasService.CalendarioProyecto(this.tarea, this.token).subscribe(
      response => {
      console.log(response);
      this.agregar_usuario = response;
    },
    error => {
      console.log(error);
    }
  );
  
console.log(this.t);
  }

  ngOnInit(): void {
    this.verTareas();
    $('select').selectpicker();
    setTimeout(() => {
      $('select').selectpicker('refresh');
    }, 1000);
    
  }
  verTareas(): void{
    this._tareasService.Calendario(this.tarea, this.token).subscribe(
        response => {
          console.log(response);
          
         let array = [];
        response.forEach(res => {
         this.allevents.push({title: res.title, start: startOfDay(new Date(res.start)), color: res.color, id: res.id_tarea});
        });
        //this.events = response;
        this.events =  this.allevents;
        this.refresh.next();
      },
      error => {
        console.log(error);
      }
    );
  }
  onSubmit(form){
    this.events = [];
    console.log(this.tarea);
    this.verTareas();
    
  }
  ngOnChanges(){
    
  }
  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    //console.log("id");
    //console.log(event);
    this.ver_info = true;
    this.ver_tarea = new NewTask(Number(event.id), null, this.id_us, '', '', '', '', '', 0, 0, false, [], '');
    //this.modalData = { event, action };
    //this.modal.open(this.modalContent, { size: 'lg' });
  }

 

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  cerrarInfo(){
    this.ver_info = false;
  }
}
